import React from "react";
// import { render }  from "react-dom";
 import * as ReactDOMClient from "react-dom/client";
import initialize from "./assets/js/main.js";
import './assets/css/fonts-new.css';
import "./assets/css/cookies.css";
import "./assets/css/fonts-new.css";
import "./assets/css/style.css";
import "./assets/css/customize.css";
import "./assets/css/ias.css";
import "./assets/css/aos.css";
import "./assets/css/header-menu.css";
import "./web.config";

import Routes from "./routes";
import registerServiceWorker from "./registerServiceWorker";

const root = ReactDOMClient.createRoot(document.getElementById("root"));
root.render(
  <Routes />
);
// ReactDOM.render(<Routes />, document.getElementById("root"));

// const container = document.getElementById("root");
//  render(
//     <Routes />,
//   container
// );
registerServiceWorker();
initialize();
